import React from 'react'
import { inject, observer } from 'mobx-react'
import { Table } from 'antd'
import { logsStore } from 'store'

import logTypes from '../logTypes'

import moment from 'moment'
import { withRouter } from 'react-router'

@inject((store: any) => {
    const { logsStore } = store
    return { logsStore }
})
@observer
class LogsList extends React.Component<any, any> {
    handleSubmitSearch = () => {
        logsStore.getLogsList()
    }
    render() {
        const { list, loading } = this.props.logsStore
        const { selectedType, history } = this.props
        const displayFields = selectedType ? logTypes[selectedType].displayFields : null
        const columns = displayFields
            ? Object.keys(displayFields).map(key => ({
                  title: displayFields[key],
                  key,
                  align: 'right',
                  width: key === 'keywords' && 350,
                  render: (_, { _source: item }) => {
                      if (key in item) {
                          return (
                              <span>{key === 'date' ? moment(item[key]).format('DD/MM/YYYY HH:mm') : item[key]}</span>
                          )
                      } else if (key === 'keywords') {
                          return (
                              <span>
                                  <strong>{item.attributes[key] || item.attributes['name']}</strong> ב
                                  {logTypes[item.subType].title}
                              </span>
                          )
                      } else if (key in item.attributes) {
                          if (key === 'user_id') {
                              return (
                                  <a
                                      style={{ color: 'black', textDecoration: 'underline' }}
                                      href={`/clients/${item.attributes[key]}`}
                                      target="_blank"
                                  >
                                      {item.attributes[key]}
                                  </a>
                              )
                          } else {
                              return <span>{item.attributes[key]}</span>
                          }
                      } else {
                          return <span>--</span>
                      }
                  }
              }))
            : [{}]
        return (
            displayFields && (
                <Table
                    className="center-table"
                    style={{ width: '100%', cursor: 'pointer' }}
                    rowKey="_id"
                    loading={loading}
                    columns={columns}
                    dataSource={list}
                    pagination={{ pageSize: 10 }}
                    onRow={record => {
                        return {
                            onClick: () => {
                                history.push(`/logs/${record._id}`)
                            }
                        }
                    }}
                />
            )
        )
    }
}

export default withRouter(LogsList)
